import type {
  DeleteUserFailed,
  DeleteUserRequest,
  DeleteUserSucceeded,
  LoadAccessibleFleetsFailed,
  LoadAccessibleFleetsRequest,
  LoadAccessibleFleetsSucceeded,
  LoadUserAttributesFailed,
  LoadUserAttributesRequest,
  LoadUserAttributesSucceeded,
  LoadUsersFailed,
  LoadUsersRequest,
  LoadUsersSucceeded,
} from './actions';
import { UsersActionTypes } from './actionTypes';

import type { AccessibleFleet, User } from '@cobliteam/common-types';

import type { UserAttributes } from '@cobliteam/api-lib';

export const loadUsersRequest = (): LoadUsersRequest => ({
  type: UsersActionTypes.LOAD_USERS_REQUEST,
});

export const loadUsersRequestSucceeded = (
  users: User[]
): LoadUsersSucceeded => ({
  type: UsersActionTypes.LOAD_USERS_SUCCEEDED,
  payload: users,
});

export const loadUsersRequestFailed = (): LoadUsersFailed => ({
  type: UsersActionTypes.LOAD_USERS_FAILED,
});

export const deleteUserRequest = (user: User): DeleteUserRequest => ({
  type: UsersActionTypes.DELETE_USER_REQUEST,
  payload: user,
});

export const deleteUserRequestSucceeded = (): DeleteUserSucceeded => ({
  type: UsersActionTypes.DELETE_USER_SUCCEEDED,
});

export const deleteUserRequestFailed = (): DeleteUserFailed => ({
  type: UsersActionTypes.DELETE_USER_FAILED,
});

export const loadUserAttributesRequest = (): LoadUserAttributesRequest => ({
  type: UsersActionTypes.LOAD_USER_ATTRIBUTES_REQUEST,
});

export const loadUserAttributesSucceeded = (
  userAttributes: UserAttributes
): LoadUserAttributesSucceeded => ({
  type: UsersActionTypes.LOAD_USER_ATTRIBUTES_SUCCEEDED,
  payload: userAttributes,
});

export const loadUserAttributesFailed = (): LoadUserAttributesFailed => ({
  type: UsersActionTypes.LOAD_USER_ATTRIBUTES_FAILED,
});

export const loadAcessibleFleetsRequest = (): LoadAccessibleFleetsRequest => ({
  type: UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_REQUEST,
});

export const loadAccessibleFleetsSucceeded = (
  accessibleFleets: AccessibleFleet[]
): LoadAccessibleFleetsSucceeded => ({
  type: UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_SUCCEEDED,
  payload: accessibleFleets,
});

export const loadAccessibleFleetsFailed = (): LoadAccessibleFleetsFailed => ({
  type: UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_FAILED,
});
